import { TableInfo } from '@pp/core/src/store/slices/launcher/types';

export interface LauncherTableInfo extends TableInfo {
  url: string;
  showClose?: boolean;
  isActive?: boolean;
  isMtbMinimized?: boolean;
}

export interface LauncherState {
  tables: LauncherTableInfo[];
  enableMultiTable: boolean;
  showFullscreen: boolean;
}

export enum GAME_POPUPS {
  LEAVE_BACCARAT_MULTIPLAY = 'LEAVE_BACCARAT_MULTIPLAY',
}
